import { render } from "./RegistrationWaitForConfirmation.vue?vue&type=template&id=3a1b2592&scoped=true&ts=true"
import script from "./RegistrationWaitForConfirmation.vue?vue&type=script&lang=ts"
export * from "./RegistrationWaitForConfirmation.vue?vue&type=script&lang=ts"

import "./RegistrationWaitForConfirmation.vue?vue&type=style&index=0&id=3a1b2592&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a1b2592"]])

export default __exports__